export const GA_TRACKING_ID = 'G-MH8EQ7CRTB';

// Log pageview
export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};
